import { render, staticRenderFns } from "./AuthSignupApp.vue?vue&type=template&id=56297d44&"
import script from "./AuthSignupApp.vue?vue&type=script&lang=ts&"
export * from "./AuthSignupApp.vue?vue&type=script&lang=ts&"
import style0 from "./AuthSignupApp.vue?vue&type=style&index=0&id=56297d44&prod&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports